<template>
	<div>
		<div class="bg4">
			<div class="bottom">
				<p>青岛市保险学会 版权所有 All Rights Reserved <a  href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备14001811号-1</a></p>
				<p>邮编：266061　投稿电子邮箱：qdbxxh@126.com</p>
			
			</div>
			<div class="bottom3">
				<p>青岛市保险学会 版权所有 .All Rights Reserved</p>
				<p><a  href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备14001811号-1</a></p>
				<p>邮编：266061　投稿电子邮箱：qdbxxh@126.com</p>
				
			</div>
			<div class="bottom2" ><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37020202001656">鲁公网安备 37020202001656号1310号</a></div>
			<!--shouji bottom-->
		</div>
	</div>

</template>
<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			go(url) {
				if (this.$route.fullPath != url) {
					this.$router.push(url)
					this.$router.go(0)
				}
			}
		}

	}
</script>
<style scoped>


</style>